import { createFileRoute, redirect } from "@tanstack/react-router";

/** Where people land: the dashboard (which sends those who may not see it on to the worklist). */
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard" });
  },
});
